import React, { useEffect } from 'react';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import { FormikHelpers } from 'formik';

import Page from '../../../components/Page';
import AuthShell from '../../../components/ui/AuthShell';
import LoginForm, { ILoginValues } from './loginForm';
import { handlePromise } from '../../../utils/handlePromisse';
import { loginWithEmail, updateToken } from '../../../services/authService'
import { useModal } from '../../../contexts/modal';
import MCAlert from '../../../components/ModalContents/MCAlert';
import { useAuth } from '../../../contexts/auth2';
import { tokenToUser } from '../../../services/userService';
import { setFeatureFlags } from '../../../services/feature-flags.service';

const dictErrorMessages: any = {
  401: 'Erro ao tentar se autenticar!',
  403: 'Senha incorreta!',
  406: 'Email não encontrado!',
  500: 'Estamos passando por ajustes técnicos, agradecemos sua compreensão!'
}

const LoginPage: React.FC = () => {

  const { setUser } = useAuth()
  const { setModalContent, setModalOpen } = useModal()
  const navigate = useNavigate()

  const onSubmit = async (values: ILoginValues, actions: FormikHelpers<ILoginValues>) => {
    const [ result, error ] = await handlePromise(loginWithEmail(values))
    if (error) {
      const status = error.response?.status
      const fallbackMessage = error.response?.data?.message || 'Erro inesperado'
      const translatedMessage = dictErrorMessages[status] ?? fallbackMessage
      setModalContent(
          <MCAlert title="Erro ao fazer login" text={translatedMessage}/>
      )
      setModalOpen(true)
      return
    }
    updateToken(result.data.token)
    if (result.data.featureFlags) {
      setFeatureFlags(result.data.featureFlags)
    }
    setUser(tokenToUser())
    sessionStorage.setItem('justLoggedIn', 'true')
    navigate('/dashboard')
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('sessionExpired') === 'true') {
      setModalContent(<MCAlert title="Sua sessão expirou!"/>)
      setModalOpen(true)
    }
  }, [])

  return (
    <Page title="Login | ProAtivos">
      <AuthShell
        kicker="Bem-vinda de volta"
        title="Entrar na conta"
        subtitle={
          <>
            Não possui acesso?{' '}
            <Link component={RouterLink} to="/signup" sx={{ color: 'primary.main', fontWeight: 600, textDecoration: 'none' }}>
              Inscreva-se
            </Link>
          </>
        }
      >
        <LoginForm handleSubmitProp={onSubmit} />
      </AuthShell>
    </Page>
  )
}

export default LoginPage
